import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const HeaderSection = ({ t, setLang, handleNavClick, forceScrolled = false }: any) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showLangDropdown, setShowLangDropdown] = useState(false);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('menu-open');
      document.documentElement.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
      document.documentElement.classList.remove('menu-open');
    }
    return () => {
      document.body.classList.remove('menu-open');
      document.documentElement.classList.remove('menu-open');
    };
  }, [menuOpen]);

  // Determine header and menu classes
  const headerClass = `home-header${forceScrolled ? ' scrolled sticky' : ''}`;
  const mobileMenuClass = `mobile-side-menu${menuOpen ? ' open' : ''}${forceScrolled ? ' scrolled sticky' : ''}`;

  return (
    <>
      {/* Hamburger menu for mobile - always visible at top left, transforms to X when open */}
      {/* Only render mobile-hamburger-bar for mobile, not inside desktop header */}
      <div className="mobile-hamburger-bar" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, background: 'transparent', boxShadow: 'none' }}>
        <button className={`hamburger${menuOpen ? ' open' : ''}`} onClick={() => setMenuOpen(open => !open)} aria-label={menuOpen ? 'Close menu' : 'Open menu'}>
          <span />
          <span />
          <span />
        </button>
        <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}`} style={{ display: 'inline-block' }}>
          <img src="/assets/logo.png" alt="Logo" className="mobile-logo" style={{ cursor: 'pointer' }} />
        </Link>
      </div>
      <nav className={mobileMenuClass} style={{ zIndex: 400 }}>
        <div className="mobile-menu-links">
          <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#about`} onClick={() => setMenuOpen(false)}>{t.about}</Link>
          <Link to={`/race-info?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}`} onClick={() => setMenuOpen(false)}>{t.raceInfo}</Link>
          <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#register`} onClick={() => setMenuOpen(false)}>{t.register}</Link>
          <Link to={`/results?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}`} onClick={() => setMenuOpen(false)}>{t.results}</Link>
          <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#sponsors`} onClick={() => setMenuOpen(false)}>{t.sponsors}</Link>
          <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#volunteers`} onClick={() => setMenuOpen(false)}>{t.volunteers}</Link>
          <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#contact`} onClick={() => setMenuOpen(false)}>{t.contact}</Link>
        </div>
        <div className="mobile-menu-lang-row">
          <button onClick={() => setLang('en')}>EN</button>
          <button onClick={() => setLang('mk')}>MK</button>
          <button onClick={() => setLang('al')}>AL</button>
        </div>
        <div className="mobile-menu-privacy-row">
          <a href="/privacy-policy" style={{ color: '#1e6ad6', fontWeight: 600, textDecoration: 'underline', marginLeft: 8 }}>{t.readPrivacyPolicy}</a>
        </div>
      </nav>
      {/* Overlay for menu */}
      {menuOpen && <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)} />}

      {/* Desktop header (without mobile-hamburger-bar) */}
      <header className={headerClass}>
        <div className="header-inner">
          <div className="logo-nav">
            <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}`} style={{ display: 'inline-block' }}>
              <img src="/assets/logo.png" alt="Logo" className="logo" style={{ cursor: 'pointer' }} />
            </Link>
            <nav className="nav-menu">
              <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#about`}>{t.about}</Link>
              <Link to={`/race-info?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}`}>{t.raceInfo}</Link>
              <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#register`}>{t.register}</Link>
              <Link to={`/results?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}`}>{t.results}</Link>
              <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#sponsors`} onClick={() => setMenuOpen(false)}>{t.sponsors}</Link>
              <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#volunteers`}>{t.volunteers}</Link>
              <Link to={`/?lang=${encodeURIComponent(typeof t.lang === 'string' ? t.lang : (window.localStorage.getItem('lang') || 'mk'))}#contact`}>{t.contact}</Link>
            </nav>
          </div>
          <div className="lang-selector">
            <div
              className="custom-lang-dropdown"
              onClick={e => {
                e.stopPropagation();
                setShowLangDropdown((v: boolean) => !v);
              }}
            >
              <div className="lang-dropdown-btn">
                {typeof t.lang === 'string' ? t.lang.toUpperCase() : (window.localStorage.getItem('lang') || 'MK').toUpperCase()}
                <span className="lang-dropdown-arrow">▼</span>
              </div>
              {showLangDropdown && (
                <div className="lang-dropdown-options">
                  {['en', 'mk', 'al'].map(lang => (
                    <div
                      key={lang}
                      className="lang-dropdown-option"
                      onClick={e => {
                        e.stopPropagation();
                        setLang(lang);
                        setShowLangDropdown(false);
                        const url = new URL(window.location.href);
                        url.searchParams.set('lang', lang);
                        window.history.replaceState(null, '', url.toString());
                        window.localStorage.setItem('lang', lang);
                        window.dispatchEvent(new PopStateEvent('popstate'));
                      }}
                      onMouseDown={e => e.preventDefault()}
                    >
                      {lang.toUpperCase()}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderSection;
